// extracted by mini-css-extract-plugin
export default {"container":"A6IdLAWjwinm3DQQcNo7"};